// Notes: These exported VP content are shared by VP homepage &
// Homepage => HOTEL + FLIGHT tab

'use strict'

const primaryHeadingDesktopTemplate = typeString =>
  `Save up to $625 on your ${typeString.raw[0]}`
const bannerTextTemplate = typeString =>
  `Save up to $625 when you book your ${typeString.raw[0]} together!`
const secondaryHeadingText = `Book together for our best deals`
const primaryHeadingMobileTemplate = typeString =>
  `Save up to $625 on your ${typeString.raw[0]}`

// SETI Savings first header copy on pkg homepage search form
// Keep the current text and new text in together, easy for future clean up.
const currentBannerTextTemplate = `Save up to $625 when you book your hotel and flight together!`

const getTextString = tripType => template => {
  switch (tripType) {
    case 'AHC':
      return template`hotel, flight and car`
    case 'AC':
      return template`flight and car`
    case 'AH':
    default:
      return template`hotel and flight`
  }
}

export default {
  // TODO: These object keys are content used on the PKG Homepage's
  //       (/home/vacationpackages/), PKG Form SETI test clean up will
  //       reorganize these content.
  primaryHeadingDesktop: (tripType) =>
    getTextString(tripType)(primaryHeadingDesktopTemplate),
  primaryHeadingMobile: (tripType) =>
    getTextString(tripType)(primaryHeadingMobileTemplate),
  bumperText: (tripType) =>
    getTextString(tripType)(bannerTextTemplate),
  secondaryHeading: () =>
    secondaryHeadingText,
  infantsMoreThanAdultsWarning:
    "Please make sure there's at least 1 adult for each lap infant.",
  headcountMoreThanRoomsWarning:
    'Rooms accommodate up to 4 people. You may need additional rooms for your group.',
  childrenAgesWarning:
    "Please enter children's ages to get the best price for your group.",
  warningInternationalWithLapInfant:
    'Priceline does not support lap infants on international flights.',
  travelerDisclaimer: 'You may only book a package for up to 8 travelers.',

  // TODO: VP Form Integration SETI content;
  //       Need to account for SETI clean up;
  //       Will add the SETI name to TODO note when SETI name is known.
  homepageTabHeading: 'Save up to $625 on your hotel and flight',
  homepageTabSubhead: 'Book together for our best deals',
  newVPFormBumper: currentBannerTextTemplate
}
